package gr.tech.meetinggenie.models.meeting

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class WeeklyFeel {
    @SerialName("great") GREAT,
    @SerialName("solid") SOLID,
    @SerialName("meh")   MEH,
    @SerialName("rough") ROUGH;

    val label get() = when (this) {
        GREAT -> "😄 Great"
        SOLID -> "🙂 Solid"
        MEH   -> "😐 Meh"
        ROUGH -> "😵 Rough"
    }
}

@Serializable
data class PulseCheckDTO(
    var weeklyFeel: WeeklyFeel? = null,
    var blockersNote: String = ""  // paragraph; optional
)
